import React from 'react';
import PaymentSignup from '../components/payment-signup';
import memoarLogo from '../assets/memoar-logo.png';

const PaymentCancelled: React.FC = () => {
  const [showSignup, setShowSignup] = React.useState(false);

  if (showSignup) {
    return <PaymentSignup onCancel={() => setShowSignup(false)} />;
  }

  return (
    <div className="payment-result">
      {/* Header */}
      <header className="payment-result__header">
        <div className="payment-result__logo">
          <img src={memoarLogo} alt="Memoar" className="payment-result__logo-img" />
          <span className="payment-result__logo-text">memoar</span>
        </div>
      </header>

      <div className="payment-result__container">
        {/* Cancelled Icon */}
        <div className="payment-result__icon payment-result__icon--cancelled">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="payment-result__title">Payment Cancelled</h1>
        <p className="payment-result__subtitle">
          No worries, your memories are still waiting
        </p>

        <div className="payment-result__card">
          <h2 className="payment-result__card-title">What happened?</h2>
          <p style={{ margin: 0, color: 'var(--color-ricordo-600)', lineHeight: 'var(--line-height-relaxed)' }}>
            Your payment was cancelled. No charges have been made to your account.
            You can try again whenever you're ready to start preserving your memories.
          </p>
        </div>

        <div className="payment-result__actions">
          <button
            onClick={() => setShowSignup(true)}
            className="payment-result__btn payment-result__btn--primary"
          >
            Try Again
          </button>
          <a
            href="/"
            className="payment-result__btn payment-result__btn--secondary"
          >
            Return Home
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="payment-result__footer">
        <p>Memories preserved with care</p>
      </footer>
    </div>
  );
};

export default PaymentCancelled;
